import moment, { Moment } from 'moment';

export { moment, type Moment };

export const getNDaysAfter = (n: number = 7): string => {
  const today = moment();
  const futureDate = today.add(n, 'days');
  return futureDate.format('YYYY-MM-DD');
};

export const get30SecondsFromNow = (): string => {
  const now = moment();
  const futureDate = now.add(30, 'seconds');
  return futureDate.format('YYYY-MM-DD HH:mm:ss');
};

export const getExpiredDaysAgo = (dueDate?: string | null): number => {
  const currentDate = moment();

  return currentDate.diff(moment(dueDate, 'YYYY-MM-DD'), 'days');
};

export const getDate = (dateString?: string | null): string => {
  if (!dateString) return '';

  const formattedDate = moment(dateString).format('MMM D, YYYY');
  return formattedDate;
};

export const getDateAgo = (date?: string | null): string => {
  if (!date) return 'now';

  // Moment considers dates not in ISO 8601 or RFC 2822 formats invalid.
  const formats = [moment.ISO_8601, moment.RFC_2822];
  const givenDate = moment(date, formats, true);

  if (!givenDate.isValid()) {
    return 'Invalid date';
  }

  return givenDate.fromNow();
};

export const getInputFormattedDateForNDaysFromNow = (n: number): string => {
  const futureDate = moment().add(n, 'days');
  return futureDate.format('YYYY-MM-DD');
};

// is past today or passed date
export const getIsPastDate = (
  dateString?: string | null,
  compareDate?: string | null,
): boolean => {
  if (!dateString) return false;

  const targetDate = moment(dateString);
  const currentDate = moment(compareDate);

  return currentDate.isAfter(targetDate);
};

export const getIsPastDateTime = (
  dateString?: string | null,
  timeString?: string | null,
  compareDateString?: string | null,
  compareTimeString?: string | null,
): boolean => {
  if (!dateString || !timeString) return false;

  const targetDateTime = moment(`${dateString} ${timeString}`);
  const currentDateTime =
    moment(`${compareDateString} ${compareTimeString}`) || moment();

  return currentDateTime.isAfter(targetDateTime);
};

// happened in last 24 hours
export const getIsPastDay = (dateString?: string | null): boolean => {
  if (!dateString) return false;

  const inputDate = moment(dateString);
  const yesterday = moment().subtract(1, 'days');

  return inputDate.isAfter(yesterday, 'minutes');
};

export const getIsRecentLogin = (lastLogin: string): boolean => {
  if (!lastLogin) return false;

  const lastLoginTime = moment(lastLogin);
  const now = moment();
  const diffInSeconds = now.diff(lastLoginTime, 'seconds');

  return diffInSeconds <= 12;
};

export const getDateFromInputs = (date: string, time: string): string => {
  const combinedDateTime = `${date} ${time}`;
  const dateTimeMoment: string = moment(
    combinedDateTime,
    'YYYY-MM-DD HH:mm:ss',
  ).toISOString();

  return dateTimeMoment;
};

export const getDateAndTimeFromString = (
  dateTime?: string | null,
): { date: string; time: string } => {
  const momentDate = moment(dateTime);

  const date = momentDate.format('YYYY-MM-DD');
  const time = momentDate.format('HH:mm:ss');

  return { date, time };
};

export const getIsOneWeekAway = (date?: string | null): boolean => {
  if (!date) return false;

  const targetDate: Moment = moment(date);
  const startOfNextWeek: Moment = moment().add(1, 'week').startOf('week');
  const endOfNextWeek: Moment = moment().add(1, 'week').endOf('week');

  return targetDate.isBetween(startOfNextWeek, endOfNextWeek, null, '[]');
};

export const getCurrentYear = (): number => {
  return moment().year();
};
